import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageHeader from 'components/PageHeader';
import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder';
import buildRoute from 'components/buildRoute';

export const CrosstabsIndexPage = () => {
  // For now, we'll just display a placeholder.
  const crosstabs = [];

  const CreateCrosstabButton = () => (
    <Button
      component={Link}
      to="new/step1"
      variant="contained"
      color="secondary"
      aria-label="Create New Crosstab"
    >
      Create New Crosstab
    </Button>
  );

  return (
    <>
      <Box sx={{ pt: 4 }}>
        <PageHeader
          title="Crosstabs"
          subtitle="Create and manage your crosstab analyses."
          action={<CreateCrosstabButton />}
        />
      </Box>
      <Box component="section">
        {crosstabs.length === 0 ? (
          <EmptyStatePlaceholder
            title="No crosstabs to show"
            subtitle="Once you create a crosstab, it will show up here."
          />
        ) : (
          <Typography>Display list of crosstabs here.</Typography>
        )}
      </Box>
    </>
  );
};

const routeArgs = {
  element: <CrosstabsIndexPage />,
  loader: async () => {
    return { crosstabs: [] }; // We'll add actual data fetching later
  },
};

export default buildRoute(routeArgs);